import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withSoftAppsModuleRoutes,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupById } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { vehicleRoutes } from './vehicle.routes';

export const provideToolModule: () => Array<Provider | EnvironmentProviders> = () => [
  provideSoftAppsModule(
    {
      name: 'tool',
      title: 'Kleingeräte Verwaltung',
      icon: 'fa-regular fa-charging-station',
      route: '/tool',
      color: 'bg-accent text-white',
      permission: 'GARAGE.TOOLS',
      group: getModuleGroupById(11),
    },
    withSoftAppsModuleRoutes({ app: vehicleRoutes }),
    withSoftAppsModuleTranslation({ de })
  ),
];

export const provideVehicleModule: () => Array<Provider | EnvironmentProviders> = () => [
  provideSoftAppsModule(
    {
      name: 'vehicle',
      title: 'Fahrzeug Verwaltung',
      icon: 'fa-regular fa-car',
      route: '/vehicle',
      permission: 'GARAGE.VEHICLES',
      color: 'bg-accent text-white',
      group: getModuleGroupById(11),
    },
    withSoftAppsModuleRoutes({ app: vehicleRoutes }),
    withSoftAppsModuleTranslation({ de })
  ),
];
